// This file was automatically generated by flagsgen. DO NOT MODIFY IT BY HAND.
// Source of truth: proxy-server/internal/flags/registry.go
// Regenerate: (cd proxy-server && make flagsgen)

export const FLAGS = {
  RELEASE_SIGHTING_PLANNER: 'release.sighting_planner',
  RELEASE_HISTORIAN_LATEST_TABLE: 'release.historian_latest_table',
  UI_SETTINGS_MOBILE_APP: 'ui.settings.mobile_app',
  UI_INGEST_CANARY: 'ui.ingest.canary',
  UI_INGEST_EXPERION: 'ui.ingest.experion',
  UI_INGEST_SRS: 'ui.ingest.srs',
  UI_INGEST_SAFETY_MANAGER: 'ui.ingest.safety_manager',
  UI_PLANT_DCS: 'ui.plant.dcs',
  UI_PLANT_NETWORK: 'ui.plant.network',
  UI_PLANT_SAFETY: 'ui.plant.safety'
} as const

export type FlagKey = (typeof FLAGS)[keyof typeof FLAGS]

export const FLAG_DEFAULTS: { readonly [K in FlagKey]: boolean } = {
  'release.sighting_planner': false,
  'release.historian_latest_table': false,
  'ui.settings.mobile_app': false,
  'ui.ingest.canary': false,
  'ui.ingest.experion': false,
  'ui.ingest.srs': false,
  'ui.ingest.safety_manager': false,
  'ui.plant.dcs': false,
  'ui.plant.network': false,
  'ui.plant.safety': false
}

export type FlagCategory = 'release' | 'entitlement' | 'ops'

export const FLAG_CATEGORIES: { readonly [K in FlagKey]: FlagCategory } = {
  'release.sighting_planner': 'release',
  'release.historian_latest_table': 'release',
  'ui.settings.mobile_app': 'entitlement',
  'ui.ingest.canary': 'entitlement',
  'ui.ingest.experion': 'entitlement',
  'ui.ingest.srs': 'entitlement',
  'ui.ingest.safety_manager': 'entitlement',
  'ui.plant.dcs': 'entitlement',
  'ui.plant.network': 'entitlement',
  'ui.plant.safety': 'entitlement'
}

export const OPS_FLAG_KEYS = [] as const satisfies readonly FlagKey[]

export type FlagSnapshotSource = 'defaults' | 'postgres' | 'override'

export type FlagSnapshot = {
  flags: { readonly [K in FlagKey]: boolean }
  evaluated_at: string
  source: FlagSnapshotSource
}
